export enum HomeDataManagerType {
  HOMEDATAMANAGERTYPE_DEFAULT = 0,
  HOMEDATAMANAGERTYPE_BANNER = 1, // banner类型
  HOMEDATAMANAGERTYPE_COLLECTION = 2, // 合集
  HOMEDATAMANAGERTYPE_RANK = 3, // 排行榜
  HOMEDATAMANAGERTYPE_RECOMMEND = 4, // 推荐卡
  HOMEDATAMANAGERTYPE_MULTI_COLLECTION = 6, // 多合集
  HOMEDATAMANAGERTYPE_OFFICIALGROUP = 7, // 官方群
}

export enum BotDataManagerType {
  BOTDATAMANAGERTYPE_DEFAULT = 0,
  BOTDATAMANAGERTYPE_BANNER = 1,
  BOTDATAMANAGERTYPE_COLLECTION = 2,
  BOTDATAMANAGERTYPE_ACCORDION = 3,
  BOTDATAMANAGERTYPE_RECENT_VISIT = 4,
}

export enum HomeDataStyle {
  HOMEDATASTYLE_DEFAULT = 0,
  HOMEDATASTYLE_BANNER = 1, // banner类型
  HOMEDATASTYLE_HORIZONTAL_SLIDE = 2, // 横向滑动
  HOMEDATASTYLE_VERTICAL_SLIDE = 3, // 竖向滑动
  HOMEDATASTYLE_RECOMMEND_STORY = 4, // 推荐故事
  HOMEDATASTYLE_RECENT = 5, //
  HOMEDATASTYLE_MULTIPLE_COLLECTION = 6,
  HOMEDATASTYLE_OFFICIALGROUP = 7, // 官方群
}

export const PromotionOrgDataKey = {
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_DEFAULT]: 'default',
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_BANNER]: 'banner',
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_COLLECTION]: 'collection',
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_RANK]: 'rank',
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_RECOMMEND]: 'recommendStory',
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_MULTI_COLLECTION]: 'multiCollection',
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_OFFICIALGROUP]: 'officialActivity',
};

export const PlazaOrgDataKey = {
  [BotDataManagerType.BOTDATAMANAGERTYPE_DEFAULT]: 'default',
  [BotDataManagerType.BOTDATAMANAGERTYPE_BANNER]: 'banner',
  [BotDataManagerType.BOTDATAMANAGERTYPE_COLLECTION]: 'collection',
  [BotDataManagerType.BOTDATAMANAGERTYPE_ACCORDION]: 'accordion',
  [BotDataManagerType.BOTDATAMANAGERTYPE_RECENT_VISIT]: 'visit',
};

export enum LabelType {
  DEFAULT = 0,
  HOT = 1, // 热度
}
